import '../sass/style.scss'
import AOS from 'aos';
import {tns} from '../../node_modules/tiny-slider/src/tiny-slider';
import $ from 'jquery';
import select2 from 'select2';

(function() {

    'use strict';

    // Allow us to add a fade-in class in Gutenberg to trigger AOS animations
    $( '.fade-up' ).attr( 'data-aos', 'fade-up' );
    $( '.fade-right' ).attr( 'data-aos', 'fade-right' );

    // AOS Init
    AOS.init( {
        once: true 
    } );

    // Init
    navToggle();
    testimonialSlideShow();

    function navToggle() {
        $( '.navicon' ).click( function() {
            $( 'body' ).toggleClass( 'nav-is-active' );
        } );
    }

    // Testimonial Slideshow
    function testimonialSlideShow() {

        if ( $( '.b40-testimonials-slider' ).length <= 0 ) {
            return;
        }

        var slider = tns( {
            container: '.b40-testimonials-slider',
            controls: false,
            navPosition: 'bottom'
        } );
    }
    
})();
